/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { modulesFormDataInputQuestionDataAttributeSchema } from './ModulesFormDataInputQuestionDataAttributeSchema'
import { modulesFormDataInputQuestionDataSubtypeSchema } from './ModulesFormDataInputQuestionDataSubtypeSchema'
import { modulesFormDataInputQuestionDataTypeSchema } from './ModulesFormDataInputQuestionDataTypeSchema'

export const modulesFormDataInputQuestionDataSchema = z.object({
	id: z.string().uuid().nullable(),
	label: z.string(),
	type: modulesFormDataInputQuestionDataTypeSchema,
	attribute: modulesFormDataInputQuestionDataAttributeSchema.nullable(),
	subtype: modulesFormDataInputQuestionDataSubtypeSchema.nullable(),
	validationRules: z.array(z.string()).nullable(),
	position: z.number(),
	options: z.array(
		z.object({
			id: z.string().nullable(),
			label: z.string(),
			position: z.number(),
			isDisqualifying: z.boolean().nullable().default(false),
			scoreValue: z.number().nullable(),
			consentType: z.string().nullable(),
		}),
	).nullable(),
	scores: z.array(z.object({ questionId: z.string().uuid(), optionId: z.string(), scoreValue: z.number() }))
		.nullable(),
	weight: z.number().nullable(),
})

export type ModulesFormDataInputQuestionDataSchema = z.infer<typeof modulesFormDataInputQuestionDataSchema>
